import {
    connectBaseApi,
    createRpcMutation,
    adminClient,
} from "@racoon/api";

const adminRpcApi = connectBaseApi.injectEndpoints({
    endpoints: (build) => ({
        impersonateUser: createRpcMutation(build, adminClient, "impersonateUser"),
    }),
    overrideExisting: false,
});

export const { useImpersonateUserMutation } = adminRpcApi;